// Dependencias
import Phaser from 'phaser';
import axiosInstance from '../../../../services/AxiosInstance';
import { startDeferring, stopDeferring, dispararSaldoFinal } from '../../../../utils/saldoControl';

// Funciones JuegoBlackJack
import { creacionElementosPrincipal } from './creacionElementos/creacionElementosPrincipal';
import { creacionParametrosPrincipal } from './creacionParametros/creacionParametrosPrincipal';

class JuegoBlackJack extends Phaser.Scene {
  /*/=======================================================================================\*\
  ||                               //? Constructor                                           ||
  \*\=======================================================================================/*/

  constructor() {
    super({ key: 'JuegoBlackJack' });
  }

  /*/=======================================================================================\*\
  ||                               Inicio Precarga                                           ||
  \*\=======================================================================================/*/

  preload() {}

  /*/=======================================================================================\*\
  ||                               Inicio Create                                             ||
  \*\=======================================================================================/*/

  create() {
    creacionElementosPrincipal(this);
    creacionParametrosPrincipal(this);
    this.mostrarApuestaTotal();
    //this.mostrarPremioTotal();
    this.verificarPartidaActiva();

    this.events.once('shutdown', () => {
      clearTimeout(this._timeoutPremio);
    });
    this.events.once('destroy', () => {
      clearTimeout(this._timeoutPremio);
    });
  }

  /**
   * Verifica si existe una partida activa en el servidor (reconexión).
   * Si existe, restaura el estado visual de la partida.
   */
  async verificarPartidaActiva() {
    try {
      const res = await axiosInstance.get('/api/partidaBlackjack/estado');
      if (res.data.activa) {
        this.restaurarPartida(res.data);
      }
    } catch (err) {
      // No hay partida activa, continuar normal
    }
  }

  /**
   * Restaura visualmente una partida activa del servidor
   */
  restaurarPartida(data) {
    startDeferring();
    this.game.saldoPendiente = null;
    this.partidaId = data.id;

    // Si ya finalizó, no hay nada que restaurar visualmente
    if (data.estado === 'FINALIZADA') {
      stopDeferring();
      return;
    }

    this.desactivarBotonesFase1();
    this.apuestaTotal = data.apuesta_base;
    this.mostrarApuestaTotal();

    // Restaurar cartas del jugador (mano 1)
    const mano1 = data.manos_jugador[0];
    let colCartasJ1 = mano1.cartas.map((c) => [c[0], c[1], c[2], c[3], null]);
    let mano1Jugador1 = [
      colCartasJ1,
      mano1.valor,
      mano1.apuesta,
      0,
      480 + colCartasJ1.length * 40,
      228,
      mano1.resultado || 'Indefinido',
      mano1.seguro || 0,
      mano1.recompensa_seguro || 0,
      '-',
    ];
    this.colJugadores[1][1] = [mano1Jugador1];

    // Mostrar cartas del jugador visualmente
    let xJ = 480;
    for (let i = 0; i < colCartasJ1.length; i++) {
      colCartasJ1[i][4] = this.add.sprite(xJ, 228, `carta${colCartasJ1[i][0]}`);
      xJ += 40;
    }
    this.indiceCartaManoJugador = colCartasJ1.length;

    this.displayValorCartasJugador1Mano1Valido.setVisible(true);
    this.mostrarValorMano1Jugador1Display();

    // Restaurar cartas del dealer
    const crupierCartas = data.mano_crupier.cartas;
    let colCartasD = crupierCartas.map((c) => [c[0], c[1], c[2], c[3], null]);
    let manoDealer = [
      colCartasD,
      data.mano_crupier.valor,
      0,
      0,
      480 + colCartasD.length * 40,
      56,
      'Indefinido',
      0,
      0,
      '-',
    ];
    this.colJugadores[0][1] = [manoDealer];

    // Mostrar cartas del dealer visualmente
    let xD = 480;
    for (let i = 0; i < colCartasD.length; i++) {
      colCartasD[i][4] = this.add.sprite(xD, 56, `carta${colCartasD[i][0]}`);
      xD += 40;
    }

    // Si el estado requiere carta oculta, agregar placeholder para la 2da carta
    if (data.estado === 'TURNO_JUGADOR' || data.estado === 'SEGURO_OFRECIDO') {
      let cartaOculta = [0, 0, '', '', null];
      cartaOculta[4] = this.add.sprite(xD, 56, 'reversoCarta1');
      colCartasD.push(cartaOculta);
      manoDealer[4] = 480 + colCartasD.length * 40;
      xD += 40;
    }
    this.indiceCartaManoDealer = colCartasD.length;

    this.displayValorCartasDealerManoValido.setVisible(true);
    this.mostrarValorManoDealerDisplay();

    // Restaurar split si existe
    if (data.tiene_split && data.manos_jugador.length > 1) {
      this.esSplit = true;
      const mano2 = data.manos_jugador[1];
      let colCartasM2 = mano2.cartas.map((c) => [c[0], c[1], c[2], c[3], null]);
      let mano2Jugador = [
        colCartasM2,
        mano2.valor,
        mano2.apuesta,
        0,
        640 + colCartasM2.length * 40,
        156,
        mano2.resultado || 'Indefinido',
        0,
        0,
        '-',
      ];
      this.colJugadores[1][1][1] = mano2Jugador;

      let xM2 = 640;
      for (let i = 0; i < colCartasM2.length; i++) {
        colCartasM2[i][4] = this.add.sprite(
          xM2,
          156,
          `carta${colCartasM2[i][0]}`
        );
        xM2 += 40;
      }
      this.indiceCartaMano2Jugador = colCartasM2.length;

      this.displayValorCartasJugador1Mano2Valido.setVisible(true);
      this.mostrarValorMano2Jugador1Display();

      this.apuestaTotal = mano1.apuesta + mano2.apuesta;

      this.displayApuestaJugador1Mano2.setVisible(true);
      this.mostrarMontoApuestaMano2Display(mano2.apuesta);
      this.fichaJugador1Mano2.setVisible(true);

      this.manoSplitActiva = data.mano_activa;
      if (data.mano_activa === 0) {
        this.flechaManoMano1.setVisible(true);
      } else {
        this.flechaManoMano2.setVisible(true);
      }
    }

    // Restaurar seguro si fue pagado
    if (mano1.seguro > 0) {
      this.displayApuestaJugador1Seguro.setVisible(true);
      this.mostrarMontoSeguroDisplay(mano1.seguro);
      this.mostrarFichaSeguro();
    }

    // Activar el panel correcto
    if (data.estado === 'SEGURO_OFRECIDO') {
      this.ocultarPanelFase1();
      this.mostrarPanelSeguro();
    } else if (data.estado === 'TURNO_JUGADOR') {
      this.ocultarPanelFase1();
      this.indiceManoJugador = data.mano_activa;
      this.mostrarPanelFase2();
    }
  }

  /*/=======================================================================================\*\
  ||                                                                                         ||
  ||                                                                                         ||
  ||                            FUNCIONES BOTONES  FASE 2                                    ||
  ||                                                                                         ||
  ||                                                                                         ||
  \*\=======================================================================================/*/

  async pedirCartaJugador() {
    this.desactivarBotonDoblarApuesta();
    this.desactivarBotonDividirMano();
    this.desactivarBotonesFase2();

    try {
      const res = await axiosInstance.post('/api/partidaBlackjack/hit');
      const data = res.data;
      const manoIdx = this.esSplit ? this.manoSplitActiva : 0;
      const manoServidor = data.manos_jugador[manoIdx];
      const cartaNueva = manoServidor.cartas[manoServidor.cartas.length - 1];

      let cartaAdicional = [
        cartaNueva[0],
        cartaNueva[1],
        cartaNueva[2],
        cartaNueva[3],
        null,
      ];
      const indiceCarta =
        this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][0]
          .length;

      this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][0][
        indiceCarta
      ] = cartaAdicional;

      this.repartirCarta(
        this,
        this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][4],
        this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][5],
        this.indiceJugador,
        this.indiceManoJugador,
        indiceCarta
      );

      this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][4] += 40;
      this.indiceCartaManoJugador = indiceCarta + 1;

      this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][1] =
        manoServidor.valor;

      if (this.esSplit && this.manoSplitActiva === 1) {
        this.mostrarValorMano2Jugador1Display();
      } else {
        this.mostrarValorMano1Jugador1Display();
      }

      // Verificar si la partida terminó
      if (data.estado === 'FINALIZADA') {
        this.time.delayedCall(1000, () => {
          // Mostrar cartel de excede 21 antes de la animación del dealer
          if (manoServidor.valor > 21) {
            if (this.esSplit && this.manoSplitActiva === 1) {
              this.mostrarCartelJugador1Mano2Excede21();
            } else {
              this.mostrarCartelJugador1Excede21();
            }
          }
          this.procesarResultadoFinal(data);
        });
      } else if (data.mano_activa !== manoIdx && this.esSplit) {
        // Cambió de mano (split)
        this.time.delayedCall(1000, () => {
          if (manoServidor.valor > 21) {
            this.mostrarCartelJugador1Excede21();
          }
          this.cambiarAManoSplit(data.mano_activa);
        });
      } else if (manoServidor.valor > 21) {
        this.time.delayedCall(1000, () => {
          if (this.esSplit && this.manoSplitActiva === 1) {
            this.mostrarCartelJugador1Mano2Excede21();
          } else {
            this.mostrarCartelJugador1Excede21();
          }
        });
      } else if (manoServidor.valor === 21) {
        // Auto-stand ya manejado por el servidor
      } else {
        if (this.activarBotonesFase2Split) this.activarBotonesFase2Split();
        if (!this.esSplit) {
          this.noVaMas = false;
          this.botonPedirCarta.setTexture('botonPedirCartaEstatico');
          this.botonPlantarme.setTexture('botonPlantarmeEstatico');
        }
      }
    } catch (err) {
      console.error('Error al pedir carta:', err);
      if (this.esSplit) {
        this.activarBotonesFase2Split();
      } else {
        this.activarBotonesFase2();
      }
    }
  }

  async plantarme() {
    this.desactivarBotonesFase2();

    try {
      const res = await axiosInstance.post('/api/partidaBlackjack/stand');
      const data = res.data;

      if (data.estado === 'FINALIZADA') {
        this.procesarResultadoFinal(data);
      } else if (this.esSplit && data.mano_activa !== this.manoSplitActiva) {
        this.cambiarAManoSplit(data.mano_activa);
      } else if (this.esSplit) {
        // El backend avanzó a la misma mano que ya teníamos activa.
        // Ocurre cuando ambas manos tienen 21 desde el reparto inicial del split:
        // la primera llamada a plantarme() adelanta mano_activa de 0 a 1,
        // y esta segunda llamada resuelve la partida.
        const manoActual = this.colJugadores[this.indiceJugador][1][data.mano_activa];
        if (manoActual && manoActual[1] === 21) {
          this.time.delayedCall(300, () => this.plantarme());
        }
      }
    } catch (err) {
      console.error('Error al plantarse:', err);
      if (this.esSplit) {
        this.activarBotonesFase2Split();
      } else {
        this.activarBotonesFase2();
      }
    }
  }

  /**
   * Procesa el resultado final enviado por el servidor.
   * Revela la carta oculta del dealer con animación, reparte las cartas
   * adicionales del dealer una a una, y muestra los carteles de resultado.
   */
  procesarResultadoFinal(data) {
    if (this.esSplit) {
      this.flechaManoMano1.setVisible(false);
      this.flechaManoMano2.setVisible(false);
    }

    const cartasCrupier = data.mano_crupier.cartas;
    const crupierActual =
      this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][0];

    // Paso 1: Actualizar datos de la carta oculta con los datos reales del servidor
    if (cartasCrupier.length >= 2 && crupierActual.length >= 2) {
      const cartaReal = cartasCrupier[1];
      crupierActual[1][0] = cartaReal[0];
      crupierActual[1][1] = cartaReal[1];
      crupierActual[1][2] = cartaReal[2];
      crupierActual[1][3] = cartaReal[3];
    }

    // Paso 2: Revelar la carta oculta del dealer con la animación de volteo
    this.revelarCartaDealer();

    // Paso 3: Preparar cartas extra del dealer (las que sacó después de las 2 iniciales)
    const cartasExtra = cartasCrupier.slice(crupierActual.length);
    let xDealer =
      this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][4];

    // Función recursiva: reparte cartas extra del dealer una a una con animación
    const repartirCartasExtraDealer = (index) => {
      if (index >= cartasExtra.length) {
        // Todas las cartas repartidas, mostrar resultados tras una pausa
        this.time.delayedCall(1000, () => {
          this.mostrarResultadosFinales(data);
        });
        return;
      }

      this.time.delayedCall(900, () => {
        const c = cartasExtra[index];
        const cartaD = [c[0], c[1], c[2], c[3], null];
        crupierActual.push(cartaD);
        const idxEnMano = crupierActual.length - 1;

        this.repartirCarta(
          this,
          xDealer,
          56,
          this.indiceDealer,
          this.indiceManoDealer,
          idxEnMano
        );
        this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][4] =
          xDealer + 40;
        this.indiceCartaManoDealer = idxEnMano + 1;

        // Actualizar valor del dealer en display
        const valorParcial = this.calcularValorMano(crupierActual);
        this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][1] =
          valorParcial;
        this.mostrarValorManoDealerDisplay();

        xDealer += 40;

        repartirCartasExtraDealer(index + 1);
      });
    };

    // Esperar a que la animación de revelado de la carta oculta termine
    this.time.delayedCall(500, () => {
      if (cartasExtra.length === 0) {
        // No hay cartas extra, mostrar resultados tras una pausa
        this.time.delayedCall(1000, () => {
          this.mostrarResultadosFinales(data);
        });
      } else {
        repartirCartasExtraDealer(0);
      }
    });
  }

  /**
   * Muestra los carteles de resultado para jugador y dealer,
   * establece el premio total y llama a finalizarRonda.
   */
  mostrarResultadosFinales(data) {
    const resultado = data.resultado;
    const manos = data.manos_jugador;

    if (this.esSplit) {
      // Mano 1
      const res1 = manos[0].resultado;
      if (res1 === 'Win') this.mostrarCartelJugador1Gana();
      else if (res1 === 'Tie') this.mostrarCartelJugador1Empate();
      else if (res1 === 'Lose') this.mostrarCartelJugador1Pierde();
      else if (res1 === 'Busts') this.mostrarCartelJugador1Excede21();

      // Mano 2
      if (manos.length > 1) {
        const res2 = manos[1].resultado;
        if (res2 === 'Win') this.mostrarCartelJugador1Mano2Gana();
        else if (res2 === 'Tie') this.mostrarCartelJugador1Mano2Empate();
        else if (res2 === 'Lose') this.mostrarCartelJugador1Mano2Pierde();
        else if (res2 === 'Busts')
          this.mostrarCartelJugador1Mano2Excede21();
      }
    } else {
      const res1 = manos[0].resultado;
      if (res1 === 'BlackJack') this.mostrarCartelJugador1BlackJack();
      else if (res1 === 'BlackJack - Tie') {
        this.mostrarCartelJugador1BlackJack();
        // El cartel del dealer se muestra en la sección de carteles del dealer (abajo)
      } else if (res1 === 'Win') this.mostrarCartelJugador1Gana();
      else if (res1 === 'Tie') this.mostrarCartelJugador1Empate();
      else if (res1 === 'Lose') this.mostrarCartelJugador1Pierde();
      else if (res1 === 'Busts') this.mostrarCartelJugador1Excede21();
    }

    // Carteles del dealer
    const resCrupier = resultado.resultadoCrupier;
    if (resCrupier === 'Busts') this.mostrarCartelDealerExcede21();
    else if (resCrupier === 'BlackJack') this.mostrarCartelDealerBlackJack();

    // Establecer premio total y datos de resultado
    this.premioTotal = resultado.totalRecompensa;
    this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][6] =
      resCrupier;

    for (let i = 0; i < manos.length; i++) {
      if (this.colJugadores[this.indiceJugador][1][i]) {
        this.colJugadores[this.indiceJugador][1][i][6] = manos[i].resultado;
        this.colJugadores[this.indiceJugador][1][i][3] = manos[i].apuesta;
      }
    }

    this.finalizarRonda();
  }

  revelarCartaDealer() {
    this.colJugadores[this.indiceDealer][1][
      this.indiceManoDealer
    ][0][1][4].destroy();

    this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][0][1][4] =
      this.add.sprite(520, 56, 'reversoCarta1Revelando');
    this.colJugadores[this.indiceDealer][1][
      this.indiceManoDealer
    ][0][1][4].play('reversoCarta1RevelandoAnimado');

    this.time.delayedCall(150, () => {
      this.colJugadores[this.indiceDealer][1][
        this.indiceManoDealer
      ][0][1][4].destroy();

      this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][0][1][4] =
        this.add.sprite(
          520,
          56,
          `carta${
            this.colJugadores[this.indiceDealer][1][
              this.indiceManoDealer
            ][0][1][0]
          }`
        );

      const valorManoDealer = this.calcularValorMano(
        this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][0]
      );
      this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][1] =
        valorManoDealer;

      this.displayValorCartasDealerManoValido.setVisible(true);
      this.mostrarValorManoDealerDisplay();
    });
  }

  espiarCartaDealer() {
    this.colJugadores[this.indiceDealer][1][
      this.indiceManoDealer
    ][0][1][4].destroy();

    this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][0][1][4] =
      this.add.sprite(520, 56, 'reversoCarta1Espiando');
    this.colJugadores[this.indiceDealer][1][
      this.indiceManoDealer
    ][0][1][4].play('reversoCarta1EspiandoAnimado');

    this.time.delayedCall(700, () => {
      this.colJugadores[this.indiceDealer][1][
        this.indiceManoDealer
      ][0][1][4].destroy();

      this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][0][1][4] =
        this.add.image(520, 56, `reversoCarta1`);
    });
  }

  calcularValorMano(colCartas) {
    let valorMano = 0;
    let ases = 0;

    for (let i = 0; i < colCartas.length; i++) {
      const carta = colCartas[i];
      const valorCarta = carta[1];

      if (valorCarta === 11) {
        ases += 1;
      }
      valorMano += valorCarta;
    }

    while (valorMano > 21 && ases > 0) {
      valorMano -= 10;
      ases -= 1;
    }

    return valorMano;
  }

  /* Repartir una carta */
  repartirCarta(
    scene,
    destinoX,
    destinoY,
    indiceJugador,
    indiceManoJugador,
    indiceCartaManoJugador
  ) {
    // Crear un nuevo reverso de carta para la animación
    const reversoCarta = scene.add.sprite(784, 56, 'reversoCarta1');
    scene.tweens.add({
      targets: reversoCarta,
      x: destinoX,
      y: destinoY,
      duration: 500,
      ease: 'Power2',
      onComplete: () => {
        // Cambiar sprite a animación de revelado
        reversoCarta.destroy();
        const cartaRevelando = scene.add.sprite(
          destinoX,
          destinoY,
          'reversoCarta1Revelando'
        );
        cartaRevelando.play('reversoCarta1RevelandoAnimado');

        scene.time.delayedCall(150, () => {
          cartaRevelando.destroy();

          scene.colJugadores[indiceJugador][1][indiceManoJugador][0][
            indiceCartaManoJugador
          ][4] = scene.add.sprite(
            destinoX,
            destinoY,
            `carta${scene.colJugadores[indiceJugador][1][indiceManoJugador][0][indiceCartaManoJugador][0]}`
          );
        });
      },
    });
  }

  repartirCartaOculta(
    scene,
    destinoX,
    destinoY,
    indiceJugador,
    indiceManoJugador,
    indiceCartaManoJugador
  ) {
    // Crear un nuevo reverso de carta para la animación
    const reversoCarta = scene.add.sprite(784, 56, 'reversoCarta1');
    scene.tweens.add({
      targets: reversoCarta,
      x: destinoX,
      y: destinoY,
      duration: 500,
      ease: 'Power2',
      onComplete: () => {
        // Cambiar sprite a animación de revelado
        reversoCarta.destroy();
        scene.colJugadores[indiceJugador][1][indiceManoJugador][0][
          indiceCartaManoJugador
        ][4] = scene.add.sprite(destinoX, destinoY, `reversoCarta1`);
      },
    });
  }

  /*/=======================================================================================\*\
  ||                                                                                         ||
  ||                                                                                         ||
  ||                                   FUNCIONES BOTONES                                     ||
  ||                                         FASE 1                                          ||
  ||                                                                                         ||
  \*\=======================================================================================/*/

  /**
   * BOTON SUMAR
   *
   * Si el usuario tiene saldo disponible y la apuesta total no supera los 2000,
   * se suma el valor de la ficha seleccionada a la apuesta total
   */
  sumarApuesta() {
    const saldoDisponible = this.game.saldoDisponible;
    const apuestaTotal = this.apuestaTotal;
    const valorFicha = this.fichaSeleccionadaValor;
    this.ultimaFichaColocada = valorFicha;

    if (
      apuestaTotal + valorFicha <= saldoDisponible &&
      apuestaTotal + valorFicha <= 2000
    ) {
      this.fichasColocadas.push(valorFicha);
      this.actualizarApuestaTotal(valorFicha);
      this.mostrarFichaColocada(valorFicha);
    }
  }

  /**
   * BOTON RESTAR
   *
   * Se quita la última ficha colocada del stack y se resta su valor de la apuesta total.
   * Si quedan fichas en el stack, se muestra la ficha anterior (top del stack).
   * Si no quedan fichas, se oculta la ficha de la alfombra.
   */
  restarApuesta() {
    if (this.fichasColocadas.length > 0) {
      const valorFichaQuitada = this.fichasColocadas.pop();
      this.apuestaTotal -= valorFichaQuitada;
      this.mostrarApuestaTotal();

      if (this.fichasColocadas.length > 0) {
        // Mostrar la ficha anterior (la que queda en el tope del stack)
        const fichaAnterior =
          this.fichasColocadas[this.fichasColocadas.length - 1];
        this.ultimaFichaColocada = fichaAnterior;
        this.mostrarFichaColocada(fichaAnterior);
      } else {
        // No quedan fichas, ocultar la ficha de la alfombra
        this.ultimaFichaColocada = 0;
        this.mostrarFichaColocada(0);
      }
    }
  }

  /**
   * BOTON BORRAR
   *
   * Si existe una apuesta mayor a 0 borra la imagen asociada a la última ficha mostrada
   * y vuelve a 0 el valor de la apuesta total
   */
  borrarApuesta() {
    this.fichasColocadas = [];
    this.ultimaFichaColocada = 0;
    this.apuestaTotal = 0;
    this.mostrarApuestaTotal();
    this.mostrarFichaColocada(0);
  }

  /**
   * BOTON JUGAR
   *
   * Si el usuario tiene saldo disponible y la apuesta total es mayor a 0,
   * se activa la función jugarApuesta, el juego entra en una etapa de transición
   * hacia la FASE 2
   */
  async jugarApuesta() {
    if (
      this.game.saldoDisponible >= this.apuestaTotal &&
      this.apuestaTotal > 0
    ) {
      // Diferir actualizaciones de saldo por socket durante la partida
      startDeferring();
      this.game.saldoPendiente = null;

      // Descontar visualmente la apuesta en el SessionBar
      if (this.game.onApuestaIniciada) {
        this.game.onApuestaIniciada(this.apuestaTotal);
      }

      // Desactivar botones Fase 1
      this.desactivarBotonesFase1();

      this.ultimaFichaDeApuesta = this.ultimaFichaColocada;
      this.ultimaApuestaTotal = this.apuestaTotal;
      this.ultimasFichasColocadas = [...this.fichasColocadas];

      try {
        const res = await axiosInstance.post('/api/partidaBlackjack/iniciar', {
          apuesta: this.apuestaTotal,
        });
        const data = res.data;
        this.partidaId = data.id;

        // Actualizar saldo disponible
        if (data.nuevoSaldo !== undefined) {
          this.game.saldoDisponible = data.nuevoSaldo;
        }

        const manoServidor = data.manos_jugador[0];
        const cartasJugador = manoServidor.cartas;
        const crupierCartas = data.mano_crupier.cartas;

        // ── CARTA 1 JUGADOR ──
        let carta1J = [
          cartasJugador[0][0],
          cartasJugador[0][1],
          cartasJugador[0][2],
          cartasJugador[0][3],
          null,
        ];
        let colCartasJ1 = [carta1J];
        let mano1Jugador1 = [
          colCartasJ1,
          carta1J[1],
          this.apuestaTotal,
          0,
          480,
          228,
          'Indefinido',
          0,
          0,
          '-',
        ];
        this.colJugadores[1][1] = [mano1Jugador1];

        this.repartirCarta(this, 480, 228, this.indiceJugador, 0, 0);
        this.indiceCartaManoJugador = 1;
        mano1Jugador1[4] = 520;

        this.colJugadores[this.indiceJugador][1][0][1] = cartasJugador[0][1];
        this.displayValorCartasJugador1Mano1Valido.setVisible(true);
        this.mostrarValorMano1Jugador1Display();

        // ── CARTA 1 DEALER ──
        this.time.delayedCall(700, () => {
          let carta1D = [
            crupierCartas[0][0],
            crupierCartas[0][1],
            crupierCartas[0][2],
            crupierCartas[0][3],
            null,
          ];
          let manoDealer = [
            [carta1D],
            carta1D[1],
            0,
            0,
            480,
            56,
            'Indefinido',
            0,
            0,
            '-',
          ];
          this.colJugadores[0][1] = [manoDealer];

          this.repartirCarta(this, 480, 56, this.indiceDealer, 0, 0);
          this.indiceCartaManoDealer = 1;
          manoDealer[4] = 520;

          this.colJugadores[this.indiceDealer][1][0][1] = carta1D[1];
          this.displayValorCartasDealerManoValido.setVisible(true);
          this.mostrarValorManoDealerDisplay();
        });

        // ── CARTA 2 JUGADOR ──
        this.time.delayedCall(1400, () => {
          let carta2J = [
            cartasJugador[1][0],
            cartasJugador[1][1],
            cartasJugador[1][2],
            cartasJugador[1][3],
            null,
          ];
          this.colJugadores[this.indiceJugador][1][0][0][1] = carta2J;

          this.repartirCarta(this, 520, 228, this.indiceJugador, 0, 1);
          this.indiceCartaManoJugador = 2;
          this.colJugadores[this.indiceJugador][1][0][4] = 560;

          this.colJugadores[this.indiceJugador][1][0][1] = manoServidor.valor;
          this.mostrarValorMano1Jugador1Display();
        });

        // ── CARTA 2 DEALER (oculta) ──
        this.time.delayedCall(2100, () => {
          // Creamos la 2da carta del dealer pero con imagen oculta
          let carta2D = [crupierCartas.length > 1 ? 0 : 0, 0, '', '', null];
          // No revelamos la 2da carta del dealer (el server solo mandó la 1ra)
          // Usamos una carta placeholder oculta
          this.colJugadores[this.indiceDealer][1][0][0][1] = carta2D;

          this.repartirCartaOculta(this, 520, 56, this.indiceDealer, 0, 1);
          this.indiceCartaManoDealer = 2;
          this.colJugadores[this.indiceDealer][1][0][4] = 560;
        });

        // ── EVALUAR RESULTADO INICIAL ──
        this.time.delayedCall(3000, () => {
          // Si la partida ya terminó (BJ del dealer o jugador)
          if (data.estado === 'FINALIZADA') {
            // Mostrar cartel de BJ del jugador antes de la animación del dealer
            const valorJugadorInicial = manoServidor.valor;
            if (valorJugadorInicial === 21) {
              this.mostrarCartelJugador1BlackJack();
            }
            this.procesarResultadoFinal(data);
            return;
          }

          // Si se ofrece seguro
          if (data.estado === 'SEGURO_OFRECIDO') {
            const valorManoInicialJugador = manoServidor.valor;
            if (valorManoInicialJugador === 21) {
              this.mostrarCartelJugador1BlackJack();
            }
            this.ocultarPanelFase1();
            this.mostrarPanelSeguro();
            return;
          }

          // Para otros estados (TURNO_JUGADOR), hacer peek si dealer tiene 10
          const cartaVisibleDealer = crupierCartas[0][1];
          if (cartaVisibleDealer === 10) {
            this.espiarCartaDealer();
          }

          const valorManoInicialJugador = manoServidor.valor;
          if (valorManoInicialJugador === 21) {
            this.mostrarCartelJugador1BlackJack();
          }

          this.time.delayedCall(700, () => {
            this.controlFase2();
          });
        });
      } catch (err) {
        console.error('Error al iniciar partida:', err);
        this.activarBotonesFase1();
        this.mostrarPanelFase1();
        stopDeferring();
        if (this.game.onPartidaFinalizada) {
          this.game.onPartidaFinalizada();
        }
      }
    }
  }

  /**
   * BOTON REPETIR
   *
   * Lee los datos guardados de la ultima apuesta y los reemplaza por los da la actual
   */
  repetirApuesta() {
    this.fichasColocadas = [...this.ultimasFichasColocadas];
    this.apuestaTotal = this.ultimaApuestaTotal;
    this.ultimaFichaColocada = this.ultimaFichaDeApuesta;
    this.mostrarApuestaTotal();

    if (this.fichasColocadas.length > 0) {
      const fichaTop = this.fichasColocadas[this.fichasColocadas.length - 1];
      this.mostrarFichaColocada(fichaTop);
    } else {
      this.mostrarFichaColocada(this.ultimaFichaDeApuesta);
    }
  }

  /**
   * BOTON SI (ACEPTAR SEGURO)
   */
  async aceptarSeguro() {
    const apuestaActual =
      this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][2];
    const seguroAmount = Math.floor(apuestaActual / 2);

    if (this.game.saldoDisponible >= seguroAmount) {
      this.pagoSeguroAceptado = true;

      if (this.game.onApuestaIniciada) {
        this.game.onApuestaIniciada(seguroAmount);
      }

      this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][7] =
        seguroAmount;
      this.displayApuestaJugador1Seguro.setVisible(true);
      this.mostrarMontoSeguroDisplay(seguroAmount);
      this.mostrarFichaSeguro();

      this.desactivarPanelSeguro();
      this.ocultarPanelSeguro();

      try {
        const res = await axiosInstance.post('/api/partidaBlackjack/seguro', {
          aceptar: true,
        });
        const data = res.data;

        if (data.nuevoSaldo !== undefined) {
          this.game.saldoDisponible = data.nuevoSaldo;
        }

        this.time.delayedCall(1000, () => {
          if (data.estado === 'FINALIZADA') {
            this.procesarResultadoFinal(data);
          } else {
            // Espiar carta del dealer y continuar
            this.espiarCartaDealer();
            this.time.delayedCall(700, () => {
              this.controlFase2();
            });
          }
        });
      } catch (err) {
        console.error('Error al aceptar seguro:', err);
        this.mostrarPanelSeguro();
      }
    }
  }

  /**
   * BOTON NO (RECHAZAR SEGURO)
   */
  async rechazarSeguro() {
    this.pagoSeguroRechazado = true;
    this.desactivarPanelSeguro();
    this.ocultarPanelSeguro();

    try {
      const res = await axiosInstance.post('/api/partidaBlackjack/seguro', {
        aceptar: false,
      });
      const data = res.data;

      this.time.delayedCall(1000, () => {
        if (data.estado === 'FINALIZADA') {
          this.procesarResultadoFinal(data);
        } else {
          this.espiarCartaDealer();
          this.time.delayedCall(700, () => {
            this.controlFase2();
          });
        }
      });
    } catch (err) {
      console.error('Error al rechazar seguro:', err);
      this.mostrarPanelSeguro();
    }
  }

  /**
   * BOTON DOBLAR APUESTA
   *
   * Dobla la apuesta del jugador, reparte exactamente una carta y
   * automáticamente pasa el turno al dealer (o finaliza si se pasa de 21).
   */
  async doblarApuesta() {
    const mano =
      this.colJugadores[this.indiceJugador][1][this.indiceManoJugador];
    const apuestaActual = mano[2];

    if (this.game.saldoDisponible < apuestaActual) return;

    if (this.game.onApuestaIniciada) {
      this.game.onApuestaIniciada(apuestaActual);
    }

    this.desactivarBotonesFase2();

    try {
      const res = await axiosInstance.post('/api/partidaBlackjack/double');
      const data = res.data;

      if (data.nuevoSaldo !== undefined) {
        this.game.saldoDisponible = data.nuevoSaldo;
      }

      const manoIdx = this.esSplit ? this.manoSplitActiva : 0;
      const manoServidor = data.manos_jugador[manoIdx];

      // Actualizar apuesta visual
      mano[2] = manoServidor.apuesta;
      if (this.esSplit && this.manoSplitActiva === 1) {
        this.mostrarMontoApuestaMano2Display(manoServidor.apuesta);
      } else {
        this.apuestaTotal = manoServidor.apuesta;
        this.mostrarApuestaTotal();
      }

      // La carta nueva es la última del array
      const cartaNueva = manoServidor.cartas[manoServidor.cartas.length - 1];
      let cartaAdicional = [
        cartaNueva[0],
        cartaNueva[1],
        cartaNueva[2],
        cartaNueva[3],
        null,
      ];
      const indiceCarta =
        this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][0]
          .length;

      this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][0][
        indiceCarta
      ] = cartaAdicional;

      this.repartirCarta(
        this,
        mano[4],
        mano[5],
        this.indiceJugador,
        this.indiceManoJugador,
        indiceCarta
      );

      this.indiceCartaManoJugador = indiceCarta + 1;
      mano[4] += 40;
      mano[1] = manoServidor.valor;

      if (this.esSplit && this.manoSplitActiva === 0) {
        this.mostrarValorMano1Jugador1Display();
      } else if (this.esSplit && this.manoSplitActiva === 1) {
        this.mostrarValorMano2Jugador1Display();
      } else {
        this.mostrarValorMano1Jugador1Display();
      }

      this.time.delayedCall(1000, () => {
        if (data.estado === 'FINALIZADA') {
          if (manoServidor.valor > 21) {
            if (this.esSplit && this.manoSplitActiva === 0) {
              this.mostrarCartelJugador1Excede21();
            } else if (this.esSplit && this.manoSplitActiva === 1) {
              this.mostrarCartelJugador1Mano2Excede21();
            } else {
              this.mostrarCartelJugador1Excede21();
            }
          }
          this.procesarResultadoFinal(data);
        } else if (this.esSplit && data.mano_activa !== this.manoSplitActiva) {
          if (manoServidor.valor > 21) {
            this.mostrarCartelJugador1Excede21();
          }
          this.cambiarAManoSplit(data.mano_activa);
        }
      });
    } catch (err) {
      console.error('Error al doblar apuesta:', err);
      if (this.esSplit) {
        this.activarBotonesFase2Split();
      } else {
        this.activarBotonesFase2();
      }
    }
  }

  /**
   * BOTON DIVIDIR MANO
   *
   * Separa la mano en dos manos independientes cuando las dos cartas tienen el mismo valor.
   * La segunda carta se desplaza hacia arriba-derecha y se reparte una carta nueva a cada mano.
   */
  async dividirMano() {
    const mano1 =
      this.colJugadores[this.indiceJugador][1][this.indiceManoJugador];
    const apuestaActual = mano1[2];

    this.desactivarBotonesFase2();

    if (this.game.onApuestaIniciada) {
      this.game.onApuestaIniciada(apuestaActual);
    }

    try {
      const res = await axiosInstance.post('/api/partidaBlackjack/split');
      const data = res.data;

      if (data.nuevoSaldo !== undefined) {
        this.game.saldoDisponible = data.nuevoSaldo;
      }

      this.esSplit = true;
      this.manoSplitActiva = 0;

      // Datos del servidor
      const mano1Servidor = data.manos_jugador[0];
      const mano2Servidor = data.manos_jugador[1];

      // Extraer la segunda carta visual de mano 1 (la que se moverá)
      const carta2 = mano1[0][1];

      // Crear mano 2 visual con la carta que se desplaza
      let colCartasMano2 = [];
      colCartasMano2[0] = carta2;

      let mano2 = [
        colCartasMano2,
        carta2[1],
        apuestaActual,
        0,
        680,
        156,
        'Indefinido',
        0,
        0,
        '-',
      ];

      this.colJugadores[this.indiceJugador][1][1] = mano2;

      // Eliminar segunda carta de mano 1
      mano1[0].length = 1;
      mano1[1] = this.calcularValorMano(mano1[0]);
      mano1[4] = 520;

      this.apuestaTotal = apuestaActual * 2;

      this.displayApuestaJugador1Mano2.setVisible(true);
      this.mostrarMontoApuestaMano2Display(apuestaActual);
      this.fichaJugador1Mano2.setVisible(true);
      this.sincronizarAnimaciones();

      // Animar la segunda carta hacia la posición de mano 2
      this.tweens.add({
        targets: carta2[4],
        x: 640,
        y: 156,
        duration: 500,
        ease: 'Power2',
        onComplete: () => {
          this.displayValorCartasJugador1Mano2Valido.setVisible(true);
          this.mostrarValorMano2Jugador1Display();
          this.mostrarValorMano1Jugador1Display();

          this.indiceCartaMano2Jugador = 1;
          mano2[4] = 680;

          // Repartir carta nueva a mano 1 (usando datos del servidor)
          this.time.delayedCall(500, () => {
            const cartaNuevaMano1 = mano1Servidor.cartas[1];
            this.repartirCartaSplitServidor(0, cartaNuevaMano1, () => {
              // Repartir carta nueva a mano 2
              this.time.delayedCall(700, () => {
                const cartaNuevaMano2 = mano2Servidor.cartas[1];
                this.repartirCartaSplitServidor(1, cartaNuevaMano2, () => {
                  this.time.delayedCall(500, () => {
                    const valorMano1 =
                      this.colJugadores[this.indiceJugador][1][0][1];
                    if (valorMano1 === 21) {
                      // Mano 1 tiene 21 en el reparto inicial: auto-plantarse vía
                      // servidor para que el backend avance mano_activa a 1 ANTES
                      // de activar los botones de mano 2. Sin esto el backend
                      // procesa las acciones del jugador sobre mano 1 en lugar de mano 2.
                      this.plantarme();
                    } else {
                      this.activarBotonesFase2Split();
                    }
                  });
                });
              });
            });
          });
        },
      });
      this.time.delayedCall(3500, () => {
        this.flechaManoMano1.setVisible(true);
        this.sincronizarAnimaciones();
      });
    } catch (err) {
      console.error('Error al dividir mano:', err);
      this.activarBotonesFase2();
    }
  }

  /**
   * Reparte una carta del servidor a la mano indicada del split
   */
  repartirCartaSplitServidor(indiceMano, cartaServidor, callback) {
    const mano = this.colJugadores[this.indiceJugador][1][indiceMano];
    const indiceCartaEnMano = mano[0].length;

    let cartaNueva = [
      cartaServidor[0],
      cartaServidor[1],
      cartaServidor[2],
      cartaServidor[3],
      null,
    ];
    mano[0][indiceCartaEnMano] = cartaNueva;

    this.repartirCarta(
      this,
      mano[4],
      mano[5],
      this.indiceJugador,
      indiceMano,
      indiceCartaEnMano
    );

    if (indiceMano === 0) {
      this.indiceCartaManoJugador = indiceCartaEnMano + 1;
    } else {
      this.indiceCartaMano2Jugador = indiceCartaEnMano + 1;
    }

    mano[4] += 40;

    this.time.delayedCall(700, () => {
      const valorMano = this.calcularValorMano(mano[0]);
      mano[1] = valorMano;

      if (indiceMano === 0) {
        this.mostrarValorMano1Jugador1Display();
      } else {
        this.mostrarValorMano2Jugador1Display();
      }

      if (callback) callback();
    });
  }

  /**
   * Cambia la mano activa durante un split
   * @param {number} indiceMano - 0 o 1
   */
  cambiarAManoSplit(indiceMano) {
    this.manoSplitActiva = indiceMano;

    if (indiceMano === 0) {
      this.indiceManoJugador = 0;
      this.indiceCartaManoJugador =
        this.colJugadores[this.indiceJugador][1][0][0].length;
      this.flechaManoMano1.setVisible(true);
      this.flechaManoMano2.setVisible(false);
    } else {
      this.indiceManoJugador = 1;
      this.indiceCartaManoJugador = this.indiceCartaMano2Jugador;
      this.flechaManoMano1.setVisible(false);
      this.flechaManoMano2.setVisible(true);
    }

    this.sincronizarAnimaciones();

    // Si la mano activa ya tiene 21, auto-plantarse vía servidor para que
    // resolverPartida() se ejecute correctamente en el backend
    const manoActual = this.colJugadores[this.indiceJugador][1][indiceMano];
    if (manoActual[1] === 21) {
      this.time.delayedCall(500, () => {
        this.plantarme();
      });
    } else {
      this.activarBotonesFase2Split();
    }
  }

  /**
   * Activa los botones de fase 2 para el split (sin dividir mano)
   */
  activarBotonesFase2Split() {
    this.noVaMas = false;
    this.desactivarBotonDividirMano();

    const mano =
      this.colJugadores[this.indiceJugador][1][this.indiceManoJugador];
    // Verificar si puede doblar apuesta (solo con exactamente 2 cartas)
    if (this.game.saldoDisponible >= mano[2] && mano[0].length === 2) {
      this.activarBotonDoblarApuesta();
    } else {
      this.desactivarBotonDoblarApuesta();
    }

    this.botonPedirCarta.setTexture('botonPedirCartaEstatico');
    this.botonPlantarme.setTexture('botonPlantarmeEstatico');
  }

  /*/=======================================================================================\*\
  ||                                                                                         ||
  ||                                                                                         ||
  ||             FUNCIONES DE ACCIONES DERIVADAS DE INTERACCIONES CON BOTONES                ||
  ||                                                                                         ||
  ||                                                                                         ||
  \*\=======================================================================================/*/

  /**
   * Muestra en pantalla la última ficha correspondiente a la apuesta actual del usuario
   * @param {*} valorFicha - Última ficha seleccionada por el usuario para colocar
   */
  mostrarFichaColocada(valorFicha) {
    if (this.apuestaTotal == 0 && this.imagenFichaSeleccionada != null) {
      this.imagenFichaSeleccionada.anims.stop();
      this.imagenFichaSeleccionada.destroy();
      this.imagenFichaSeleccionada = null;
    } else if (this.apuestaTotal > 0 && this.imagenFichaSeleccionada == null) {
      this.imagenFichaSeleccionada = this.add.sprite(
        500,
        304,
        `fichaAlfombra${valorFicha}`
      );
      this.imagenFichaSeleccionada.play(`fichaAlfombra${valorFicha}Animada`);
    } else if (this.apuestaTotal > 0 && this.imagenFichaSeleccionada != null) {
      this.imagenFichaSeleccionada.anims.stop();
      this.imagenFichaSeleccionada.destroy();
      this.imagenFichaSeleccionada = this.add.sprite(
        500,
        304,
        `fichaAlfombra${valorFicha}`
      );
      this.imagenFichaSeleccionada.play(`fichaAlfombra${valorFicha}Animada`);
    }
  }

  // Muestra en el display de apuesta el valor total de la apuesta
  mostrarApuestaTotal() {
    const apuestaStr = this.apuestaTotal.toString();

    let xPosition = 542;
    const yPosition = 346;

    this.limpiarApuestaTotal();

    for (let i = apuestaStr.length - 1; i >= 0; i--) {
      const digito = apuestaStr[i];

      const imagenDigito = this.add.image(
        xPosition,
        yPosition,
        `numeroDisplay${digito}`
      );
      imagenDigito.setDepth(500);
      this.imagenesNumerosApuesta.push(imagenDigito);
      xPosition -= 16;
    }
  }

  // Limpia el display de apuesta
  limpiarApuestaTotal() {
    this.imagenesNumerosApuesta.forEach((imagen) => {
      imagen.destroy();
    });
    this.imagenesNumerosApuesta = [];
  }

  // Muestra en el display el valor de la mano 1 del jugador 1
  mostrarValorMano1Jugador1Display() {
    const valorMano = this.colJugadores[this.indiceJugador][1][0][1];
    const valorManoStr = valorMano.toString();

    let xPosition = 402;
    const yPosition = 198;

    this.limpiarValorMano1Jugador1Display();

    for (let i = valorManoStr.length - 1; i >= 0; i--) {
      const digito = valorManoStr[i];

      const imagenDigito = this.add.image(
        xPosition,
        yPosition,
        `numeroDisplay${digito}`
      );
      imagenDigito.setDepth(500);
      this.imagenesValorMano1Jugador1Display.push(imagenDigito);
      xPosition -= 16;
    }
  }

  // Limpia el display del valor de la mano
  limpiarValorMano1Jugador1Display() {
    this.imagenesValorMano1Jugador1Display.forEach((imagen) => {
      imagen.destroy();
    });
    this.imagenesValorMano1Jugador1Display = [];
  }

  // Muestra en el display de apuesta el valor total de la apuesta
  mostrarValorManoDealerDisplay() {
    const valorMano =
      this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][1];
    const valorManoStr = valorMano.toString();

    let xPosition = 402;
    const yPosition = 26;

    this.limpiarValorManoDealerDisplay();

    for (let i = valorManoStr.length - 1; i >= 0; i--) {
      const digito = valorManoStr[i];

      const imagenDigito = this.add.image(
        xPosition,
        yPosition,
        `numeroDisplay${digito}`
      );
      imagenDigito.setDepth(500);
      this.imagenesValorManoDealerDisplay.push(imagenDigito);
      xPosition -= 16;
    }
  }

  // Limpia el display del valor de la mano
  limpiarValorManoDealerDisplay() {
    this.imagenesValorManoDealerDisplay.forEach((imagen) => {
      imagen.destroy();
    });
    this.imagenesValorManoDealerDisplay = [];
  }

  // Muestra en el display el valor de la mano 2 del jugador 1
  mostrarValorMano2Jugador1Display() {
    const valorMano = this.colJugadores[this.indiceJugador][1][1][1];
    const valorManoStr = valorMano.toString();

    let xPosition = 562;
    const yPosition = 126;

    this.limpiarValorMano2Jugador1Display();

    for (let i = valorManoStr.length - 1; i >= 0; i--) {
      const digito = valorManoStr[i];

      const imagenDigito = this.add.image(
        xPosition,
        yPosition,
        `numeroDisplay${digito}`
      );
      imagenDigito.setDepth(500);
      this.imagenesValorMano2Jugador1Display.push(imagenDigito);
      xPosition -= 16;
    }
  }

  // Limpia el display del valor de la mano 2
  limpiarValorMano2Jugador1Display() {
    this.imagenesValorMano2Jugador1Display.forEach((imagen) => {
      imagen.destroy();
    });
    this.imagenesValorMano2Jugador1Display = [];
  }

  // Muestra en el display el monto del seguro pagado
  mostrarMontoSeguroDisplay(monto) {
    const montoStr = monto.toString();

    let xPosition = 382;
    const yPosition = 346;

    this.limpiarMontoSeguroDisplay();

    for (let i = montoStr.length - 1; i >= 0; i--) {
      const digito = montoStr[i];

      const imagenDigito = this.add.image(
        xPosition,
        yPosition,
        `numeroDisplay${digito}`
      );
      imagenDigito.setDepth(500);
      this.imagenesMontoSeguroDisplay.push(imagenDigito);
      xPosition -= 16;
    }
  }

  // Limpia el display del monto de seguro
  limpiarMontoSeguroDisplay() {
    this.imagenesMontoSeguroDisplay.forEach((imagen) => {
      imagen.destroy();
    });
    this.imagenesMontoSeguroDisplay = [];
  }

  // Muestra la ficha de seguro sobre la alfombra
  mostrarFichaSeguro() {
    this.fichaJugador1Seguro.setVisible(true);
    this.sincronizarAnimaciones();
  }

  /**
   * Destruye y recrea todos los sprites animados visibles (fichas y flechas)
   * para que sus animaciones de brillo arranquen sincronizadas desde el frame 0.
   */
  sincronizarAnimaciones() {
    // Ficha de apuesta mano 1
    if (this.imagenFichaSeleccionada != null) {
      const fichaValor = this.ultimaFichaColocada;
      this.imagenFichaSeleccionada.anims.stop();
      this.imagenFichaSeleccionada.destroy();
      this.imagenFichaSeleccionada = this.add.sprite(
        500,
        304,
        `fichaAlfombra${fichaValor}`
      );
      this.imagenFichaSeleccionada.play(`fichaAlfombra${fichaValor}Animada`);
    }

    // Ficha de seguro
    if (this.fichaJugador1Seguro && this.fichaJugador1Seguro.visible) {
      this.fichaJugador1Seguro.destroy();
      this.fichaJugador1Seguro = this.add
        .sprite(340, 304, 'fichaAlfombraComodin')
        .setVisible(true);
      this.fichaJugador1Seguro.play('fichaAlfombraComodinAnimada');
    }

    // Ficha de mano 2
    if (this.fichaJugador1Mano2 && this.fichaJugador1Mano2.visible) {
      this.fichaJugador1Mano2.destroy();
      this.fichaJugador1Mano2 = this.add
        .sprite(660, 304, 'fichaAlfombraComodin')
        .setVisible(true);
      this.fichaJugador1Mano2.play('fichaAlfombraComodinAnimada');
    }

    // Flecha mano 1
    if (this.flechaManoMano1 && this.flechaManoMano1.visible) {
      this.flechaManoMano1.destroy();
      this.flechaManoMano1 = this.add
        .sprite(342, 198, 'flechaMano')
        .setDepth(400)
        .setVisible(true);
      this.flechaManoMano1.play('flechaManoAnimada');
    }

    // Flecha mano 2
    if (this.flechaManoMano2 && this.flechaManoMano2.visible) {
      this.flechaManoMano2.destroy();
      this.flechaManoMano2 = this.add
        .sprite(502, 126, 'flechaMano')
        .setDepth(400)
        .setVisible(true);
      this.flechaManoMano2.play('flechaManoAnimada');
    }
  }

  // Muestra en el display el monto de apuesta de la mano 2
  mostrarMontoApuestaMano2Display(monto) {
    const montoStr = monto.toString();

    let xPosition = 702;
    const yPosition = 346;

    this.limpiarMontoApuestaMano2Display();

    for (let i = montoStr.length - 1; i >= 0; i--) {
      const digito = montoStr[i];

      const imagenDigito = this.add.image(
        xPosition,
        yPosition,
        `numeroDisplay${digito}`
      );
      imagenDigito.setDepth(500);
      this.imagenesMontoApuestaMano2Display =
        this.imagenesMontoApuestaMano2Display || [];
      this.imagenesMontoApuestaMano2Display.push(imagenDigito);
      xPosition -= 16;
    }
  }

  // Limpia el display del monto de apuesta mano 2
  limpiarMontoApuestaMano2Display() {
    if (this.imagenesMontoApuestaMano2Display) {
      this.imagenesMontoApuestaMano2Display.forEach((imagen) => {
        imagen.destroy();
      });
    }
    this.imagenesMontoApuestaMano2Display = [];
  }

  // Muestra en el display de premio el valor total del premio
  mostrarPremioTotal() {
    const premioStr = this.premioTotal.toString();

    let xPosition = 974;
    const yPosition = 470;

    this.limpiarPremioTotal();

    for (let i = premioStr.length - 1; i >= 0; i--) {
      const digito = premioStr[i];

      const imagenDigito = this.add.image(
        xPosition,
        yPosition,
        `numeroDisplay${digito}`
      );
      imagenDigito.setDepth(500);
      this.imagenesNumerosPremio.push(imagenDigito);
      xPosition -= 16;
    }
  }

  // Actualiza el premio total mostrando los números intermedio en el display
  actualizarPremioTotal() {
    let xPosition = 974;
    const yPosition = 470;
    let acumGanancia = 0;
    const premioFinal = this.premioTotal;
    let aumentoIteracion = 5000;

    if (premioFinal >= 10000 && premioFinal < 100000) {
      aumentoIteracion = 500;
    } else if (premioFinal >= 100 && premioFinal < 100000) {
      aumentoIteracion = 50;
    } else if (premioFinal >= 10 && premioFinal < 100) {
      aumentoIteracion = 5;
    }

    const updateDisplay = () => {
      this.limpiarPremioTotal();

      // Convierte el valor actual a cadena
      const acumGananciaStr = acumGanancia.toString();

      // Reposiciona xPosition en cada iteración para cada número completo
      let currentXPosition = xPosition;

      for (let i = acumGananciaStr.length - 1; i >= 0; i--) {
        const digito = acumGananciaStr[i];
        const imagenDigito = this.add.image(
          currentXPosition,
          yPosition,
          `numeroDisplay${digito}`
        );
        imagenDigito.setDepth(500);
        this.imagenesNumerosPremio.push(imagenDigito);
        currentXPosition -= 16;
      }

      // Incrementa acumGanancia sin exceder premioFinal
      if (acumGanancia < premioFinal) {
        acumGanancia = Math.min(acumGanancia + aumentoIteracion, premioFinal); // Ajusta incremento sin superar premioFinal
        this._timeoutPremio = setTimeout(updateDisplay, 1); // Retraso de 1 ms entre cada incremento
      }
    };

    updateDisplay();
  }

  // Limpia el display de premio
  limpiarPremioTotal() {
    this.imagenesNumerosPremio.forEach((imagen) => {
      imagen.destroy();
    });
    this.imagenesNumerosPremio = [];
  }

  /**
   * cambia al valor de la ficha seleccionada por el valor recibido por parámetro
   * @param {integer} valor Entero que tiene el valor de la ficha seleccionada
   */
  cambiarFichaSeleccionadaValor(valor) {
    this.fichaSeleccionadaValor = valor;
  }

  /**
   * Suma a la apuesta total el valor recibido por parámetro
   * @param {integer} valorFicha Entero que tiene el valor de la ficha a sumar a la apuesta
   */
  actualizarApuestaTotal(valorFicha) {
    this.apuestaTotal += valorFicha;
    this.mostrarApuestaTotal();
  }

  /*/=======================================================================================\*\
  ||                                                                                         ||
  ||                                                                                         ||
  ||                                      CONTROL FASE SEGURO                                ||
  ||                                                                                         ||
  ||                                                                                         ||
  \*\=======================================================================================/*/

  /**
   * SI DEALER TIENE UN AS hace el primer control previo a terminar la fase 1
   */
  controlFaseSeguro() {
    const valorManoInicialJugador =
      this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][1];

    if (valorManoInicialJugador == 21) {
      this.mostrarCartelJugador1BlackJack();
    }

    const valorCartaReveladaDealer =
      this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][0][0][1];

    /*
    CASO ESPECIAL 1
    1 - El crupier muestra un AS, lo que inmediatamente activa el 
    panel de pagar seguro.
    2 - la función mostrarPanelSeguro CONTROLA el resto de los casos
    */
    if (valorCartaReveladaDealer == 11) {
      this.ocultarPanelFase1();
      this.mostrarPanelSeguro(); //CONTROLA SIGUIENTE PASO
      /*
      CASO ESPECIAL 2
      1 - El crupier muestra una carta con valor 10, lo que inmediatamente activa
      el espiar la carta del crupier.
      */
    } else {
      this.controlFase1();
    }
  }

  /*/=======================================================================================\*\
  ||                                                                                         ||
  ||                                                                                         ||
  ||                                      CONTROL FASE 1                                     ||
  ||                                                                                         ||
  ||                                                                                         ||
  \*\=======================================================================================/*/

  /**
   * Control de la fase 1 cuando el dealer no tiene un AS
   */
  controlFase1() {
    const valorManoInicialJugador =
      this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][1];
    const valorManoInicialDealer =
      this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][1];

    const valorCartaReveladaDealer =
      this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][0][0][1];

    if (
      valorCartaReveladaDealer == 10 ||
      this.pagoSeguroRechazado ||
      this.pagoSeguroAceptado
    ) {
      this.espiarCartaDealer();
      this.time.delayedCall(700, () => {
        /**
         * Luego de espiar la carta pueden pasar varios casos
         */

        // Calcular pago de seguro si fue aceptado
        if (this.pagoSeguroAceptado) {
          const seguro =
            this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][7];
          if (valorManoInicialDealer == 21) {
            // Dealer tiene BJ → seguro paga 2:1 (se devuelve seguro + 2x ganancia)
            this.colJugadores[this.indiceJugador][1][
              this.indiceManoJugador
            ][8] = seguro * 3;
          } else {
            // Dealer no tiene BJ → seguro se pierde
            this.colJugadores[this.indiceJugador][1][
              this.indiceManoJugador
            ][8] = 0;
          }
        }

        // DEALER Y JUGADOR TIENEN BLACKJACK
        if (
          valorManoInicialJugador == 21 &&
          valorManoInicialDealer == valorManoInicialJugador
        ) {
          this.revelarCartaDealer();
          this.mostrarCartelDealerBlackJack();

          // REGISTRO RESULTADOS DE JUGADA
          this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][6] =
            'BlackJack - Empate';
          this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][6] =
            'BlackJack - Empate';
          //Actualizo la recompensa de la mano del jugador para registrar en la bd
          this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][3] =
            this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][2];
          //Actualizo el premio total del jugador para mostrarlo dentro del juego
          this.premioTotal =
            this.colJugadores[this.indiceJugador][1][
              this.indiceManoJugador
            ][3] +
            this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][8];

          this.finalizarRonda();
        } else if (valorManoInicialJugador == 21) {
          this.revelarCartaDealer();

          // REGISTRO RESULTADOS DE JUGADA
          this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][6] =
            'BlackJack';
          this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][6] =
            '-';

          //Actualizo la recompensa de la mano del jugador para registrar en la bd
          this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][3] =
            this.colJugadores[this.indiceJugador][1][
              this.indiceManoJugador
            ][2] * 2.5;
          //Actualizo el premio total del jugador para mostrarlo dentro del juego
          this.premioTotal =
            this.colJugadores[this.indiceJugador][1][
              this.indiceManoJugador
            ][3] +
            this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][8];

          this.finalizarRonda();
        } else if (valorManoInicialDealer == 21) {
          this.revelarCartaDealer();
          this.mostrarCartelDealerBlackJack();
          this.mostrarCartelJugador1Pierde();

          // REGISTRO RESULTADOS DE JUGADA
          this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][6] =
            'Pierde';
          this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][6] =
            'BlackJack';

          //Actualizo la recompensa de la mano del jugador para registrar en la bd
          this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][3] =
            0;
          //Actualizo el premio total del jugador para mostrarlo dentro del juego
          this.premioTotal =
            this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][8];

          this.finalizarRonda();
        } else {
          this.controlFase2();
        }
      });
    } else {
      if (valorManoInicialJugador == 21) {
        this.revelarCartaDealer();

        // REGISTRO RESULTADOS DE JUGADA
        this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][6] =
          'BlackJack';
        this.colJugadores[this.indiceDealer][1][this.indiceManoDealer][6] = '-';

        //Actualizo la recompensa de la mano del jugador para registrar en la bd
        this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][3] =
          this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][2] *
          2.5;
        //Actualizo el premio total del jugador para mostrarlo dentro del juego
        this.premioTotal =
          this.colJugadores[this.indiceJugador][1][this.indiceManoJugador][3];

        this.finalizarRonda();
      } else {
        this.controlFase2();
      }
    }
  }

  /*/=======================================================================================\*\
  ||                                                                                         ||
  ||                                                                                         ||
  ||                                      CONTROL FASE 2                                     ||
  ||                                                                                         ||
  ||                                                                                         ||
  \*\=======================================================================================/*/

  controlFase2() {
    this.ocultarPanelFase1();
    this.mostrarPanelFase2();
    this.mostrarPremioTotal();
  }

  /*/=======================================================================================\*\
  ||                                                                                         ||
  ||                                                                                         ||
  ||                               FINZALIZA LA RONDA                                        ||
  ||                                                                                         ||
  ||                                                                                         ||
  \*\=======================================================================================/*/

  /**
   * Muestra el resultado de la ronda en pantalla y reinicia el juego.
   */
  async finalizarRonda() {
    // Ocultar panel fase 1 (botones y fichas) y mostrar display de premio
    this.ocultarPanelFase1();
    this.ocultarPanelFase2();
    this.displayPremio.setVisible(true);

    this.actualizarPremioTotal(); // Muestro en pantalla el resultado de la jugada

    // Actualizar saldo 1 segundo después de mostrar el resultado
    this.time.delayedCall(1000, () => {
      const saldoFinal =
        this.game.saldoPendiente != null
          ? this.game.saldoPendiente
          : this.game.saldoDisponible + this.premioTotal;
      dispararSaldoFinal(saldoFinal);
      stopDeferring();
    });

    //------------------------------------ FINALIZA JUGADA --------------------------------------\\

    this.time.delayedCall(4000, () => {
      this.limpiarPremioTotal();
      this.reiniciarJuego();
    });
  }

  /**
   * Reinicia todos los valores del juego a 0
   */
  reiniciarJuego() {
    // Iterar sobre los jugadores
    for (let jugador of this.colJugadores) {
      if (jugador[1] !== null) {
        // Iterar sobre las manos de cada jugador
        for (let mano of jugador[1]) {
          // Liberar las imágenes asociadas a las cartas
          for (let carta of mano[0]) {
            carta[4].destroy(); // Destruir la imagen de la carta
            carta[4] = null; // Eliminar la referencia a la imagen
          }
          // Reiniciar los valores de la mano
          mano[0] = []; // Vaciar las cartas
          mano[1] = 0; // Valor total de las cartas
          mano[2] = 0; // Apuesta total
          mano[3] = 0; // Recompensa
          mano[4] = 0; // Posición x próxima carta
          mano[5] = 0; // Posición y próxima carta
          mano[6] = 'Indefinido'; // Resultado
          mano[7] = 0; // Seguro
          mano[8] = 0; // Recompensa del seguro
        }
        // Reiniciar la colección de manos del jugador
        jugador[1] = [];
      }
    }

    this.indiceJugador = 1;
    this.indiceManoJugador = 0;
    this.indiceCartaManoJugador = 0;

    this.indiceDealer = 0;
    this.indiceManoDealer = 0;
    this.indiceCartaManoDealer = 0;

    this.pagoSeguroRechazado = false;
    this.pagoSeguroAceptado = false;
    this.noVaMas = false;
    this.apuestaTotal = 0;
    this.premioTotal = 0;

    // Limpiar elementos de split
    this.esSplit = false;
    this.manoSplitActiva = 0;
    this.indiceCartaMano2Jugador = 0;
    this.flechaManoMano1.setVisible(false);
    this.flechaManoMano2.setVisible(false);

    // Limpiar displays de seguro
    this.limpiarMontoSeguroDisplay();
    this.displayApuestaJugador1Seguro.setVisible(false);
    this.fichaJugador1Seguro.setVisible(false);

    // Limpiar displays de mano 2
    this.limpiarValorMano2Jugador1Display();
    this.limpiarMontoApuestaMano2Display();
    this.displayValorCartasJugador1Mano2.setVisible(false);
    this.displayValorCartasJugador1Mano2Valido.setVisible(false);
    this.displayApuestaJugador1Mano2.setVisible(false);
    this.fichaJugador1Mano2.setVisible(false);

    this.displayValorCartasDealerManoValido.setVisible(false);
    this.displayValorCartasJugador1Mano1Valido.setVisible(false);
    this.limpiarValorMano1Jugador1Display();
    this.limpiarValorManoDealerDisplay();

    this.ocultarCartelesManoResultados();
    this.ocultarPanelFase2();

    // Aplicar saldo real pendiente al balance interno del juego
    if (this.game.saldoPendiente != null) {
      this.game.saldoDisponible = this.game.saldoPendiente;
      this.game.saldoPendiente = null;
    }

    // Fallback HTTP por si el socket no llegó durante la partida
    if (this.game.onPartidaFinalizada) {
      this.game.onPartidaFinalizada();
    }

    this.fichasColocadas = [];
    this.mostrarFichaColocada(0);
    this.mostrarApuestaTotal();
    //this.mostrarPremioTotal();
    this.mostrarPanelFase1();
    this.activarBotonesFase1();
  }

  /*/=======================================================================================\*\
  ||                                                                                         ||
  ||                                                                                         ||
  ||                                   FUNCIONES DE CONTROL                                  ||
  ||                                       DE BOTONES                                        ||
  ||                                                                                         ||
  \*\=======================================================================================/*/

  /*/=======================================================================================\*\
  ||                               PANEL ACCIONES FASE 1                                     ||
  \*\=======================================================================================/*/
  desactivarBotonesFase1() {
    this.noVaMas = true;
    this.botonSumar.setTexture('botonSumarDesactivado');
    this.botonRestar.setTexture('botonRestarDesactivado');
    this.botonBorrar.setTexture('botonBorrarDesactivado');
    this.botonJugar.setTexture('botonJugarDesactivado');
    this.botonRepetir.setTexture('botonRepetirDesactivado');
  }

  activarBotonesFase1() {
    this.noVaMas = false;
    this.botonSumar.setTexture('botonSumarEstatico');
    this.botonRestar.setTexture('botonRestarEstatico');
    this.botonBorrar.setTexture('botonBorrarEstatico');
    this.botonJugar.setTexture('botonJugarEstatico');
    this.botonRepetir.setTexture('botonRepetirEstatico');
  }

  ocultarPanelFase1() {
    this.ocultarBotonesFase1();
    this.ocultarFichasFase1();
  }

  ocultarBotonesFase1() {
    this.botonSumar.setVisible(false);
    this.botonRestar.setVisible(false);
    this.botonBorrar.setVisible(false);
    this.botonJugar.setVisible(false);
    this.botonRepetir.setVisible(false);
  }

  ocultarFichasFase1() {
    this.fichaEleccion10.setVisible(false);
    this.fichaEleccion20.setVisible(false);
    this.fichaEleccion50.setVisible(false);
    this.fichaEleccion100.setVisible(false);
  }

  mostrarPanelFase1() {
    this.mostrarBotonesFase1();
    this.mostrarFichasFase1();
  }

  mostrarBotonesFase1() {
    this.botonSumar.setVisible(true);
    this.botonRestar.setVisible(true);
    this.botonBorrar.setVisible(true);
    this.botonJugar.setVisible(true);
    this.botonRepetir.setVisible(true);
  }

  mostrarFichasFase1() {
    this.fichaEleccion10.setVisible(true);
    this.fichaEleccion20.setVisible(true);
    this.fichaEleccion50.setVisible(true);
    this.fichaEleccion100.setVisible(true);
  }

  /*/=======================================================================================\*\
  ||                            PANEL ACCIONES PAGO SEGURO                                   ||
  \*\=======================================================================================/*/

  mostrarPanelSeguro() {
    this.noVaMas = false;
    this.botonSiSeguro.setTexture('botonSiSeguroEstatico');
    this.botonNoSeguro.setTexture('botonNoSeguroEstatico');
    this.botonSiSeguro.setVisible(true);
    this.botonNoSeguro.setVisible(true);
    this.mensajePanelPagarSeguro.setVisible(true);
  }

  ocultarPanelSeguro() {
    this.noVaMas = true;
    this.botonSiSeguro.setVisible(false);
    this.botonNoSeguro.setVisible(false);
    this.mensajePanelPagarSeguro.setVisible(false);
  }

  desactivarPanelSeguro() {
    this.noVaMas = true;
    this.botonSiSeguro.setTexture('botonSiSeguroDesactivado');
    this.botonNoSeguro.setTexture('botonNoSeguroDesactivado');
  }

  /*/=======================================================================================\*\
  ||                               PANEL ACCIONES FASE 2                                     ||
  \*\=======================================================================================/*/
  desactivarBotonDoblarApuesta() {
    this.puedeDoblarApuesta = false;
    this.botonDoblarApuesta.setTexture('botonDoblarApuestaDesactivado');
  }

  activarBotonDoblarApuesta() {
    this.puedeDoblarApuesta = true;
    this.botonDoblarApuesta.setTexture('botonDoblarApuestaEstatico');
  }

  desactivarBotonDividirMano() {
    this.puedeDividirMano = false;
    this.botonDividirMano.setTexture('botonDividirManoDesactivado');
  }

  activarBotonDividirMano() {
    this.puedeDividirMano = true;
    this.botonDividirMano.setTexture('botonDividirManoEstatico');
  }

  desactivarBotonesFase2() {
    this.noVaMas = true;
    this.botonDividirMano.setTexture('botonDividirManoDesactivado');
    this.botonDoblarApuesta.setTexture('botonDoblarApuestaDesactivado');
    this.botonPedirCarta.setTexture('botonPedirCartaDesactivado');
    this.botonPlantarme.setTexture('botonPlantarmeDesactivado');
  }

  activarBotonesFase2() {
    this.noVaMas = false;
    const mano =
      this.colJugadores[this.indiceJugador][1][this.indiceManoJugador];
    const apuestaActual = mano[2];

    // Activar botón dividir solo si las cartas tienen el mismo valor y hay saldo suficiente
    if (
      mano[0][0][1] == mano[0][1][1] &&
      this.game.saldoDisponible >= apuestaActual
    ) {
      this.activarBotonDividirMano();
    } else {
      this.desactivarBotonDividirMano();
    }

    // Activar botón doblar solo si hay saldo suficiente y exactamente 2 cartas
    if (this.game.saldoDisponible >= apuestaActual && mano[0].length === 2) {
      this.puedeDoblarApuesta = true;
      this.botonDoblarApuesta.setTexture('botonDoblarApuestaEstatico');
    } else {
      this.desactivarBotonDoblarApuesta();
    }

    this.botonPedirCarta.setTexture('botonPedirCartaEstatico');
    this.botonPlantarme.setTexture('botonPlantarmeEstatico');
  }

  ocultarPanelFase2() {
    this.ocultarBotonesFase2();
  }

  ocultarBotonesFase2() {
    this.botonDividirMano.setVisible(false);
    this.botonDoblarApuesta.setVisible(false);
    this.botonPedirCarta.setVisible(false);
    this.botonPlantarme.setVisible(false);
    this.displayPremio.setVisible(false);
  }

  mostrarPanelFase2() {
    this.mostrarBotonesFase2();
    if (this.esSplit) {
      this.activarBotonesFase2Split();
    } else {
      this.activarBotonesFase2();
    }
  }

  mostrarBotonesFase2() {
    this.botonDividirMano.setVisible(true);
    this.botonDoblarApuesta.setVisible(true);
    this.botonPedirCarta.setVisible(true);
    this.botonPlantarme.setVisible(true);
    this.displayPremio.setVisible(true);
  }

  /*/=======================================================================================\*\
  ||                               CARTELES RESULTADOS JUGADOR 1                             ||
  \*\=======================================================================================/*/

  ocultarCartelesManoResultados() {
    this.cartelJugador1Mano1BlackJack.setVisible(false);
    this.cartelJugador1Mano1Gana.setVisible(false);
    this.cartelJugador1Mano1Empate.setVisible(false);
    this.cartelJugador1Mano1Pierde.setVisible(false);
    this.cartelJugador1Mano1Excede21.setVisible(false);

    this.cartelJugador1Mano2BlackJack.setVisible(false);
    this.cartelJugador1Mano2Gana.setVisible(false);
    this.cartelJugador1Mano2Empate.setVisible(false);
    this.cartelJugador1Mano2Pierde.setVisible(false);
    this.cartelJugador1Mano2Excede21.setVisible(false);

    this.cartelDealerManoBlackJack.setVisible(false);
    this.cartelDealerManoGana.setVisible(false);
    this.cartelDealerManoEmpate.setVisible(false);
    this.cartelDealerManoPierde.setVisible(false);
    this.cartelDealerManoExcede21.setVisible(false);
  }

  mostrarCartelJugador1BlackJack() {
    this.cartelJugador1Mano1BlackJack.setVisible(true);
    /*
    this.time.delayedCall(5000, () => {
      this.cartelJugador1Mano1BlackJack.setVisible(false);
    });
    */
  }

  mostrarCartelJugador1Gana() {
    this.cartelJugador1Mano1Gana.setVisible(true);
    /*
    this.time.delayedCall(5000, () => {
      this.cartelJugador1Mano1Gana.setVisible(false);
    });
    */
  }

  mostrarCartelJugador1Empate() {
    this.cartelJugador1Mano1Empate.setVisible(true);
    /*
    this.time.delayedCall(5000, () => {
      this.cartelJugador1Mano1Empate.setVisible(false);
    });
    */
  }

  mostrarCartelJugador1Pierde() {
    this.cartelJugador1Mano1Pierde.setVisible(true);
    /*
    this.time.delayedCall(5000, () => {
      this.cartelJugador1Mano1Pierde.setVisible(false);
    });
    */
  }

  mostrarCartelJugador1Excede21() {
    this.cartelJugador1Mano1Excede21.setVisible(true);
    /*
    this.time.delayedCall(5000, () => {
      this.cartelJugador1Mano1Excede21.setVisible(false);
    });
    */
  }

  /*/=======================================================================================\*\
  ||                               CARTELES RESULTADOS DEALER                                ||
  \*\=======================================================================================/*/
  mostrarCartelDealerBlackJack() {
    this.cartelDealerManoBlackJack.setVisible(true);
    /*
    this.time.delayedCall(5000, () => {
      this.cartelDealerManoBlackJack.setVisible(false);
    });
    */
  }

  mostrarCartelDealerGana() {
    this.cartelDealerManoGana.setVisible(true);
    /*
    this.time.delayedCall(5000, () => {
      this.cartelDealerManoGana.setVisible(false);
    });
    */
  }

  mostrarCartelDealerEmpate() {
    this.cartelDealerManoEmpate.setVisible(true);
    /*
    this.time.delayedCall(5000, () => {
      this.cartelDealerManoEmpate.setVisible(false);
    });
    */
  }

  mostrarCartelDealerPierde() {
    this.cartelDealerManoPierde.setVisible(true);
    /*
    this.time.delayedCall(5000, () => {
      this.cartelDealerManoPierde.setVisible(false);
    });
    */
  }

  mostrarCartelDealerExcede21() {
    this.cartelDealerManoExcede21.setVisible(true);
    /*
    this.time.delayedCall(5000, () => {
      this.cartelDealerManoExcede21.setVisible(false);
    });
    */
  }

  /*/=======================================================================================\*\
  ||                               CARTELES RESULTADOS JUGADOR 1 MANO 2                     ||
  \*\=======================================================================================/*/

  mostrarCartelJugador1Mano2BlackJack() {
    this.cartelJugador1Mano2BlackJack.setVisible(true);
  }

  mostrarCartelJugador1Mano2Gana() {
    this.cartelJugador1Mano2Gana.setVisible(true);
  }

  mostrarCartelJugador1Mano2Empate() {
    this.cartelJugador1Mano2Empate.setVisible(true);
  }

  mostrarCartelJugador1Mano2Pierde() {
    this.cartelJugador1Mano2Pierde.setVisible(true);
  }

  mostrarCartelJugador1Mano2Excede21() {
    this.cartelJugador1Mano2Excede21.setVisible(true);
  }
}

export default JuegoBlackJack;
